import { useTheme } from '@emotion/react';
import CloseIcon from '@mui/icons-material/Close';
import { Grid } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { sendRequest, serviceList } from 'src/utils';
import ButtonAction from '../Button.js/SaveButton';
import NumberInput from '../Input/NumberInput';
import Loader from '../loader/loader';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};
const ImportExportDeviceModal = ({
    idDrawer,
    idCabinet,
    isReload = true,
    visible = false,
    dataUpdate,
    setVisible,
    fuctGet,
    idPermission,
    isQRCodeDevice = false,
    isImport = false,
}) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const quantityRef = useRef(null);
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const [name, setName] = useState({});
    const [Max, setMax] = useState('0');
    const [Min, setMin] = useState('');
    const [deviceCD, setDeviceCD] = useState('');
    const [cabinetCD, setCabinetCD] = useState('');

    const [quantity, setQuantity] = useState('');

    const [actionDeviceOnline, setActionDeviceOnline] = useState(false);
    const actionRef = useRef();

    const [sendEmail, setSendEmail] = useState(false);
    const sendEmailRef = useRef();
    const [openCelFlag, setOpenCelFlag] = useState(true);

    useEffect(() => {
        setDeviceCD(dataUpdate.device_cd);
        setCabinetCD(dataUpdate.cabinet_cd);
        setMax(dataUpdate.max_no);
        setQuantity('');
        setMin(dataUpdate.min_no);
        setName({ id: dataUpdate.device_id, pic_device: dataUpdate.pic_device, device_nm: dataUpdate.device_nm });
    }, [dataUpdate]);

    useEffect(() => {
        if (visible) openCell(dataUpdate);
        return () => {
            clearIntervalCheckStatusCell();
        };
    }, [visible]);

    const openCell = (data) => {
        if (!data?.cell_lc) return;
        if (actionRef.current) return;
        actionRef.current = true;
        setActionDeviceOnline(true);
        setOpenCelFlag(true);
        let service = serviceList.openCellIOT;
        let inpuVal = [data.cabinet_cd, data.drawer_lc, data.cell_lc.row, data.cell_lc.column];
        if (data?.cabinet_type !== 'round') {
            service = serviceList.openCellIOT;
            inpuVal = [data.cabinet_cd, data.drawer_lc, data.cell_lc.row, data.cell_lc.column];
        } else {
            service = serviceList.openCellIOTCabinetV2;
            inpuVal = [data.cabinet_cd, data.drawer_lc, data.cell_lc.column, data.column];
        }
        sendRequest(service, inpuVal, openCellResult, true, timeOutFunctIOT, 40000, 0);
    };

    const openCellResult = (reqInfoMap, message) => {
        setActionDeviceOnline(false);
        setOpenCelFlag(false);
        actionRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            setVisible(false);
        } else {
            // gọi api kiểm tra trạng thái ô sau 5s
            // const input_param = reqInfoMap['input_param'];
            // setTimeout(() => {
            //     handleIntervalCheckStatusCell(input_param[0], input_param[1], input_param[2]);
            // }, 5000);
            // region Xử lý khi mở ô thành công
        }
    };
    const closeCell = () => {
        setActionDeviceOnline(true);
        clearIntervalCheckStatusCell();
        let service = serviceList.closeCellIOT;
        let inpuVal = [dataUpdate.cabinet_cd, dataUpdate.drawer_lc, dataUpdate.cell_lc.row, dataUpdate.cell_lc.column];
        if (dataUpdate?.cabinet_type !== 'round') {
            service = serviceList.closeCellIOT;
            inpuVal = [dataUpdate.cabinet_cd, dataUpdate.drawer_lc, dataUpdate.cell_lc.row, dataUpdate.cell_lc.column];
        } else {
            service = serviceList.closeCellIOTCabinetV2;
            inpuVal = [dataUpdate.cabinet_cd, dataUpdate.drawer_lc, dataUpdate.cell_lc.column, dataUpdate.column];
        }
        sendRequest(service, inpuVal, closeCellResult, true, timeOutFunctIOT, 40000, 0);
    };
    const closeCellResult = (reqInfoMap, message) => {
        setActionDeviceOnline(false);
        clearIntervalCheckStatusCell();
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
        } else {
            setVisible(!visible);
        }
    };

    const timeOutFunctIOT = (reqInfo) => {
        setActionDeviceOnline(false);
        actionRef.current = false;
        setVisible(false);
        toast.error(t('error.time_out') + ': ' + 'IoT');
    };

    const handleEdit = () => {
        if (actionRef.current) return;
        if (!quantity || Min === '' || Min === null || !Max) return toast.error(t('error.param'));
        setActionDeviceOnline(true);
        actionRef.current = true;

        let InVal = [
            +idPermission,
            dataUpdate.cabinet_id,
            dataUpdate.drawer_id,
            '',
            +Max,
            +Min,
            +quantity,
            name.id, //id thiet bi
            isQRCodeDevice ? dataUpdate.cell_id : dataUpdate.id,
            'imp',
            'iwh',
        ];
        sendRequest(serviceList.updatebox, InVal, actionResult, true, timeOutFunct, 40000);
    };
    const actionResult = (reqInfoMap, message) => {
        setActionDeviceOnline(false);
        actionRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            closeCell();
            setVisible(false);
            return;
        } else {
            toast.success(message['proc_message']);
            setVisible(false);
            closeCell();
            if (isReload && isQRCodeDevice) {
                fuctGet && fuctGet(deviceCD, cabinetCD);
            } else if (isReload) {
                fuctGet && fuctGet(idCabinet, idDrawer);
            }
        }
    };

    const timeOutFunct = (reqInfo) => {
        setActionDeviceOnline(false);
        actionRef.current = false;
        toast.error(t('error.time_out'));
    };

    const handleExport = () => {
        if (!quantity) return toast.error(t('error.param'));
        if (actionRef.current) return;
        setActionDeviceOnline(true);
        actionRef.current = true;
        if (!dataUpdate.cabinet_id || !dataUpdate.drawer_id) return toast.error(t('error.system_error'));
        // if (addCabinetFlag.current === true) return;
        if (!quantity) return toast.error(t('error.param'));

        let InVal = [
            +idPermission,
            dataUpdate.cabinet_id,
            dataUpdate.drawer_id,
            +quantity,
            dataUpdate.device_id,
            isQRCodeDevice ? dataUpdate.cell_id : dataUpdate.id,
            'exp',
            'ewh',
        ];
        sendRequest(serviceList.export, InVal, actionResultExport, true, timeOutFunctExport, 40000);
    };
    const actionResultExport = (reqInfoMap, message) => {
        setActionDeviceOnline(false);
        actionRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            closeCell();
            setVisible(false);
            return;
        } else {
            toast.success(message['proc_message']);
            setVisible(!visible);
            closeCell();
            sendEmailDevice();
            if (isReload && isQRCodeDevice) {
                fuctGet && fuctGet(deviceCD, cabinetCD);
            } else if (isReload) fuctGet && fuctGet(idCabinet, idDrawer);
        }
    };

    const timeOutFunctExport = (reqInfo) => {
        setActionDeviceOnline(false);
        actionRef.current = false;
        closeCell();
        toast.error(t('error.time_out'));
    };

    const sendEmailDevice = () => {
        if (sendEmailRef.current) return;
        setSendEmail(true);
        sendEmailRef.current = true;

        let InVal = [dataUpdate.device_id, isQRCodeDevice ? dataUpdate.cell_id : dataUpdate.id];
        sendRequest(serviceList.sendEmailDevice, InVal, sendEmailDeviceResult, true, timeOutFunctSendEmail, 40000);
    };
    const sendEmailDeviceResult = (reqInfoMap, message) => {
        setSendEmail(false);
        sendEmailRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            return;
        } else {
            // console.log('Gửi thành công')
            return;
        }
    };

    const timeOutFunctSendEmail = (reqInfo) => {
        setSendEmail(false);
        sendEmailRef.current = false;
    };

    const handleClose = () => {
        closeCell();
        // setVisible(!visible);
    };

    // region checkStatusCell START
    const checkIntervalCheckStatusCell = useRef(null);
    const checkStatusCellFlag = useRef(false);
    const handleIntervalCheckStatusCell = (cabinet_cd, drawer_id, cell_address) => {
        checkIntervalCheckStatusCell.current = setInterval(() => {
            checkStatusCell(cabinet_cd, drawer_id, cell_address);
        }, 3000);
    };
    const clearIntervalCheckStatusCell = () => {
        console.log('checkIntervalCheckStatusCell.current', checkIntervalCheckStatusCell.current);
        clearInterval(checkIntervalCheckStatusCell.current);
    };
    const checkStatusCell = (cabinet_cd, drawer_id, cell_address) => {
        console.log('checkIntervalCheckStatusCell.current', checkIntervalCheckStatusCell.current);
        if (!cabinet_cd || !drawer_id || !cell_address || checkStatusCellFlag.current) return;
        checkStatusCellFlag.current = true;
        const inpuVal = [cabinet_cd, drawer_id, cell_address];
        sendRequest(
            serviceList.checkStatusCell,
            inpuVal,
            checkStatusCellResult,
            true,
            checkStatusCellTimeOut,
            40000,
            0
        );
    };
    const checkStatusCellResult = (reqInfoMap, message) => {
        checkStatusCellFlag.current = false;
        console.log(
            'checkStatusCellResult',
            (message['proc_code']?.toString() || '1') === '1' && (message['proc_status']?.toString() || '1') === '1'
        );
        if ((message['proc_code']?.toString() || '1') === '1' && (message['proc_status']?.toString() || '1') === '1') {
            closeCell();
            setVisible(false);
        }
    };
    const checkStatusCellTimeOut = (reqInfo) => {
        checkStatusCellFlag.current = false;
    };
    // region checkStatusCell END
    return (
        <BootstrapDialog
            fullScreen={fullScreen}
            open={visible}
            aria-labelledby="customized-dialog-title"
            PaperProps={{ component: 'div' }}
        >
            <BootstrapDialogTitle onClose={handleClose} id="customized-dialog-title">
                {isImport ? t('import_device') : t('export_device')}
            </BootstrapDialogTitle>
            <DialogContent dividers>
                <Loader loading={actionDeviceOnline} />
                <Grid container spacing={2}>
                    {isImport && (
                        <>
                            <Grid style={{ width: '100%' }} item xl={6} md={6} sm={6}>
                                <NumberInput label={t('Min')} valueChange={Min ? Min : 0} required getValue={setMin} />
                            </Grid>
                            <Grid style={{ width: '100%' }} item xl={6} md={6} sm={6}>
                                <NumberInput label={t('Max')} valueChange={Max ? Max : ''} required getValue={setMax} />
                            </Grid>
                        </>
                    )}
                    <Grid item style={{ width: '100%' }} xl={12} md={12} sm={12}>
                        <NumberInput
                            label={t('quantity_category')}
                            valueChange={quantity}
                            size="medium"
                            autoFocus
                            required
                            onEnterPress={handleEdit}
                            ref={quantityRef}
                            getValue={setQuantity}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions style={{ padding: '12px 16px' }}>
                <ButtonAction onClick={handleClose} type={'cancel'} title={t('cancel')} />
                <ButtonAction
                    disabled={openCelFlag}
                    onClick={isImport ? handleEdit : handleExport}
                    type={isImport ? 'import' : 'export'}
                    title={isImport ? t('import') : t('export')}
                />
            </DialogActions>
        </BootstrapDialog>
    );
};

export default ImportExportDeviceModal;
